export function normalizeUsername(value = "") {
  return String(value)
    .trim()
    .replace(/^@+/, "")
    .replace(/\s+/g, "_")
    .replace(/[^a-zA-Z0-9._-]/g, "")
    .slice(0, 30);
}

export function createHandleFromEmail(email = "", uid = "") {
  const localPart = String(email).split("@")[0] || "farmer";
  const clean = normalizeUsername(localPart.toLowerCase()) || "farmer";
  if (!uid) return clean;
  return `${clean}_${String(uid).slice(0, 4).toLowerCase()}`;
}

export function getEmailHandle(email = "") {
  const localPart = String(email).split("@")[0] || "user";
  return normalizeUsername(localPart) || "user";
}

export function resolveUserDisplayName(entity = {}, fallbackEmail = "") {
  const username = entity?.username || entity?.userName;
  if (username) return String(username);

  const display = entity?.displayName || entity?.name;
  if (display && !String(display).includes("@")) return String(display);

  const posterName = entity?.poster?.username || entity?.poster?.userName || entity?.poster?.displayName || entity?.poster?.name;
  if (posterName && !String(posterName).includes("@")) return String(posterName);

  const email = entity?.email || entity?.poster?.email || fallbackEmail;
  return getEmailHandle(email);
}

export function resolveAvatarUrl(entity = {}) {
  return entity?.photoURL || entity?.avatar || entity?.photo || entity?.poster?.photo || entity?.poster?.photoURL || "/default-avatar.png";
}
